(() => {
  if (customElements.get('custom-featured-collections')) return;

  class CustomFeaturedCollections extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.mobileMedia = window.matchMedia('(max-width: 699px)');
    }

    connectedCallback() {
      if (this.abortController.signal.aborted) this.abortController = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('.custom-featured-collections__tab'));
      this.panels = Array.from(this.querySelectorAll('.custom-featured-collections__collection'));
      this.collectionCarousel = this.querySelector('.custom-featured-collections__collections');

      this.collectionCarousel?.addEventListener(
        'carousel:change',
        (event) => this.syncCollectionState(event.detail.index),
        { signal: this.abortController.signal }
      );

      this.mobileMedia.addEventListener('change', () => this.syncResponsiveState(), {
        signal: this.abortController.signal,
      });

      const selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-current') === 'true');
      this.syncCollectionState(Math.max(selectedIndex, 0));
      this.syncResponsiveState();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    syncCollectionState(selectedIndex) {
      this.tabs.forEach((tab, index) => {
        const isSelected = index === selectedIndex;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel, index) => {
        const isSelected = index === selectedIndex;
        panel.setAttribute('aria-hidden', String(!isSelected));
        panel.toggleAttribute('inert', !isSelected);
      });
    }

    syncResponsiveState() {
      const isMobile = this.mobileMedia.matches;

      this.querySelectorAll('.custom-featured-collections__product-list').forEach((productList) => {
        if (isMobile) {
          productList.removeAttribute('aria-roledescription');
          productList.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          productList.setAttribute('aria-roledescription', 'carousel');
        }
      });

      this.querySelectorAll('.custom-featured-collections__pagination').forEach((pagination) => {
        pagination.setAttribute('aria-hidden', String(isMobile));
      });
    }
  }

  customElements.define('custom-featured-collections', CustomFeaturedCollections);
})();
